import {SectionTitle} from '@/components/molecules';
import {
  TextInput,
  Toggle,
  DatePickerInput,
  Dropdown as PepsicoDsDropdown
} from '@/components/atoms';
import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useLocation} from 'react-router-dom';
import {SegmentsCard} from '@/containers/Rewards/RewardSetup/ui-components';
import {Constants} from '@/utils/constants/commonConstants';
import './SegmentStyles.css';

import {DATE_VALIDATION_TYPE} from '@/utils/constants/commonConstants';
export const CreatePointMultiplierSection = ({
  handleUpdateValue,
  formData,
  channelJsonSchema,
  categoryJsonSchema,
  rulesCriteriaJsonSchema,
  segmentJsonSchema,
  formError,
  setDisableNext,
  setFormData
}) => {
  const location = useLocation();
  const prefillData = location.state?.formData;
  useEffect(() => {
    let d = false;
    if (formData?.rulesCriteria !== 'Products') {
      [
        'modifierName',
        'rulesCriteria',
        'rulesPriority',
        'multiplierValue',
        'activeStartDate'
      ].forEach((f) => {
        if (formData[f] == undefined || formData[f] == '') d = true;
      });
      if (
        formData['segment'] == undefined &&
        formData['channel'] == undefined &&
        formData['category'] == undefined
      ) {
        d = true;
      }
    } else {
      [
        'modifierName',
        'rulesCriteria',
        'rulesPriority',
        'activeStartDate'
      ].forEach((f) => {
        if (formData[f] == undefined || formData[f] == '') d = true;
      });
    }
    if (formData['activeEndDate'] == undefined && formData['hasEndDate']) {
      d = true;
    }
    if (formError['activeEndDate'] && formData['hasEndDate']) d = true;
    if (formError['activeStartDate']) d = true;
    if (
      formError['multiplierValue'] &&
      formData['rulesCriteria'] !== 'Products'
    )
      d = true;
    if (formError['rulesPriority']) d = true;
    setDisableNext(d);
  }, [formError, formData, setDisableNext]);
  const [rulesC, setRulesC] = useState(
    rulesCriteriaJsonSchema.properties?.rulesCriteria?.options
  );
  const [segmentList, setSegmentList] = useState(
    segmentJsonSchema?.properties?.segment?.options
  );
  const [channelList, setChannelList] = useState(
    channelJsonSchema?.properties?.channel?.options
  );
  const [categoryList, setCategoryList] = useState(
    categoryJsonSchema?.properties?.category?.options
  );
  useEffect(() => {
    setRulesC(rulesCriteriaJsonSchema?.properties?.rulesCriteria?.options);
  }, [rulesCriteriaJsonSchema]);

  useEffect(() => {
    setSegmentList(segmentJsonSchema?.properties?.segment?.options);
  }, [segmentJsonSchema]);

  useEffect(() => {
    setCategoryList(categoryJsonSchema?.properties?.category?.options);
  }, [categoryJsonSchema]);

  useEffect(() => {
    setChannelList(channelJsonSchema?.properties?.channel?.options);
  }, [channelJsonSchema]);
  useEffect(() => {
    if (prefillData) {
      setFormData({
        ...prefillData
      });
    }
  }, [prefillData, setFormData]);
  return (
    <div>
      <SectionTitle label={'Point Multiplier Setup'} />
      <div className='grid  grid-cols-12 justify-center '>
        <div className='col-span-12 max-w-72 sm:col-span-6 md:col-span-6  lg:col-span-3'>
          <div className='py-2 text-xs text-gray-100'>
            <span>Multiplier Name*</span>
          </div>
          <TextInput
            id='modifierName'
            disabled={formData?.status != null}
            placeholderText='Multiplier Name'
            value={formData?.modifierName}
            style={{background: '#272727', color: '#EFEFEF'}}
            onChange={(val) => handleUpdateValue(val, 'modifierName')}
            required={false}
          />
          {formError?.modifierName && (
            <div>
              <span
                className='text-xs'
                style={{color: 'var(--color-feedback-error-high-contrast)'}}>
                {formError?.modifierName}
              </span>
            </div>
          )}
        </div>
      </div>
      <SectionTitle label={'Rules'} />
      <div className='grid grid-cols-12 justify-center gap-4'>
        <div className='col-span-12 max-w-72 sm:col-span-6 md:col-span-6 lg:col-span-3 '>
          <div className='py-2 text-xs text-gray-200'>
            <span>Rules Criteria*</span>
          </div>
          <PepsicoDsDropdown
            isJsonWrap={false}
            isClearable={false}
            style={{width: 'inherit'}}
            key='rules-criteria'
            childList={rulesC}
            isDark={true}
            selection={'single'}
            unselectable='on'
            placeholder={'Select'}
            value={rulesC?.filter(
              (i) => i.displayText == formData?.rulesCriteria
            )}
            updateValue={(event) => handleUpdateValue(event, 'rulesCriteria')}
          />
        </div>
        <div className='col-span-12 max-w-72 sm:col-span-6 md:col-span-6  lg:col-span-3'>
          {(formData?.rulesCriteria == 'Segment' ||
            formData?.rulesCriteria == 'Products') && (
            <>
              <div
                className='point-multiplier-segment-wrapper'
                data-testid='point-multiplier-segment-wrapper'>
                <SegmentsCard
                  formData={{
                    allCustomers: false,
                    segmentExclude: false,
                    segments:
                      formData?.segment && formData.segment !== '-'
                        ? [[{id: formData.segment, name: formData.segment}]]
                        : [],
                    excludedSegments: []
                  }}
                  segments={segmentList?.map((item) => ({
                    id: item.displayText,
                    name: item.displayText
                  }))}
                  segmentsLoading={false}
                  handleAllCustomersChange={() => {}}
                  handleSegmentExcludeChange={() => {}}
                  handleSegmentsChange={(segments) => {
                    if (
                      segments &&
                      segments.length > 0 &&
                      segments[0] &&
                      segments[0].length > 0
                    ) {
                      const segment = segments[0][0];
                      handleUpdateValue([{displayText: segment}], 'segment');
                    } else {
                      handleUpdateValue([{displayText: undefined}], 'segment');
                    }
                  }}
                  handleExcludedSegmentsChange={() => {}}
                  hideAddGroup={true}
                  singleSelectMode={true}
                  label={Constants.TitleSegments}
                />
              </div>
              {formError?.segment && formData?.rulesCriteria !== 'Products' && (
                <div>
                  <span
                    className='text-xs'
                    style={{
                      color: 'var(--color-feedback-error-high-contrast)'
                    }}>
                    {formError?.segment}
                  </span>
                </div>
              )}
            </>
          )}
          {/* Category */}
          {formData?.rulesCriteria == 'Category' && (
            <>
              <div className='py-2 text-sm text-gray-200'>
                <span>Category*</span>
              </div>
              <PepsicoDsDropdown
                isJsonWrap={false}
                style={{width: 'inherit'}}
                isClearable={false}
                value={categoryList?.filter(
                  (i) => i.displayText === formData?.category
                )}
                childList={categoryList}
                isDark={true}
                selection={'single'}
                size={'medium'}
                placeholder={'Select'}
                updateValue={(event) => handleUpdateValue(event, 'category')}
              />
              {formError?.category && (
                <div>
                  <span
                    className='text-xs'
                    style={{
                      color: 'var(--color-feedback-error-high-contrast)'
                    }}>
                    {formError?.category}
                  </span>
                </div>
              )}
            </>
          )}
          {/* Channel */}
          {formData?.rulesCriteria == 'Channel' && (
            <>
              <div className='py-2 text-sm text-gray-200'>
                <span>Channel*</span>
              </div>
              <PepsicoDsDropdown
                isJsonWrap={false}
                style={{width: 'inherit'}}
                isClearable={false}
                value={channelList?.filter(
                  (i) => i.displayText === formData?.channel
                )}
                childList={channelList}
                isDark={true}
                selection={'single'}
                size={'medium'}
                placeholder={'Select'}
                updateValue={(event) => handleUpdateValue(event, 'channel')}
              />
              {formError?.category && (
                <div>
                  <span
                    className='text-xs'
                    style={{
                      color: 'var(--color-feedback-error-high-contrast)'
                    }}>
                    {formError?.channel}
                  </span>
                </div>
              )}
            </>
          )}
        </div>
        <div className='col-span-12 max-w-72 sm:col-span-6 md:col-span-6  lg:col-span-3'>
          <div className='py-2 text-xs text-gray-200'>
            <span>Rules Priority*</span>
          </div>
          <TextInput
            id='rulesPriority'
            min={1}
            type='number'
            value={formData?.rulesPriority}
            placeholderText='1/2/3/4'
            onChange={(val) => handleUpdateValue(val, 'rulesPriority')}
            handleKeyDown={(e) => {
              if (
                isNaN(e.key) &&
                e.key === '.' &&
                e.key?.toLowerCase() !== 'backspace' &&
                e.key?.toLowerCase() !== 'delete'
              ) {
                e.preventDefault();
              }
            }}
          />
          {formError?.rulesPriority && (
            <div>
              <span
                className='text-xs'
                style={{color: 'var(--color-feedback-error-high-contrast)'}}>
                {formError?.rulesPriority}
              </span>
            </div>
          )}
        </div>
        {formData?.rulesCriteria !== 'Products' && (
          <div className='col-span-12 max-w-72 sm:col-span-6 md:col-span-6  lg:col-span-3'>
            <div className='py-2 text-xs text-gray-200'>
              <span>Multiplier Value*</span>
            </div>
            <TextInput
              id='multiplierValue'
              type='text'
              value={
                formData?.multiplierValue !== undefined &&
                formData?.multiplierValue !== '' &&
                formData?.multiplierValue !== null
                  ? `${formData?.multiplierValue}x`
                  : ''
              }
              placeholderText='1x'
              onChange={(val) => {
                handleUpdateValue(val, 'multiplierValue');
              }}
              handleKeyDown={(e) => {
                if (
                  e.key?.toLowerCase() == 'backspace' ||
                  e.key?.toLowerCase() == 'delete'
                ) {
                  e.target.value = e.target.value?.slice(0, -1);
                } else if (isNaN(e.key) && e.key === '.') {
                  e.preventDefault();
                }
              }}
            />
            {formError?.multiplierValue && (
              <span
                className='text-xs'
                style={{color: 'var(--color-feedback-error-high-contrast)'}}>
                {formError?.multiplierValue}
              </span>
            )}
          </div>
        )}
      </div>
      <SectionTitle label={'Availability'} />
      <div className='mb-20 mt-4 flex flex-col gap-6'>
        <DatePickerInput
          label='activeStartDate'
          uiSchema={{
            format: 'dd/mm/yyyy',
            type: 'Control',
            className: 'box-size-width',
            placeholder: 'Choose date',
            label: 'Active Start Date*',
            inputSize: 'medium',
            endYear: 2026,
            fieldName: 'activeStartDate',
            isDark: true,
            required: false,
            validationRules: [
              {type: 'required', msg: ` is required`},
              {
                type: DATE_VALIDATION_TYPE.START_DATE,
                msg: ` can only start from a date in future`
              },
              {
                type: DATE_VALIDATION_TYPE.START_DATE_TODAY,
                msg: ` can only start from a date in future`
              }
            ]
          }}
          id='activeStartDate'
          className='max-w-72'
          updateValue={(val, isError) =>
            handleUpdateValue(val, 'activeStartDate', isError)
          }
          value={formData?.activeStartDate}
        />
        <Toggle
          uiSchema={{
            label: 'Has End Date?',
            isDark: true,
            size: 'medium',
            className: 'pre-reqsite-toggle mr-3',
            variant: 'horizontal',
            showCheckedIcon: false
          }}
          style={{fontSize: '18px', color: '#dfdfdf'}}
          value={formData?.hasEndDate}
          className='text-7xl'
          size='medium'
          variant='horizontal'
          updateValue={(val) => handleUpdateValue(val, 'hasEndDate')}
        />
        {formData?.hasEndDate && (
          <div data-testid='activeEndDate'>
            <DatePickerInput
              uiSchema={{
                format: 'dd/mm/yyyy',
                type: 'Control',
                className: 'box-size-width',
                placeholder: 'Choose date',
                label: 'Active End Date*',
                inputSize: 'medium',
                fieldName: 'activeEndate',
                isDark: true,
                required: false,
                endYear: 2026,
                dependentDate: formData?.activeStartDate,
                validationRules: [
                  {type: 'required', msg: ` is required`},
                  {
                    type: DATE_VALIDATION_TYPE.END_DATE,
                    msg: ` cannot be less than start date`,
                    startDate: formData?.activeStartDate
                  }
                ]
              }}
              id='activeEndDate'
              className='max-w-72'
              updateValue={(val, isError) =>
                handleUpdateValue(val, 'activeEndDate', isError)
              }
              value={formData?.activeEndDate}
            />
          </div>
        )}
      </div>
    </div>
  );
};

CreatePointMultiplierSection.propTypes = {
  handleUpdateValue: PropTypes.func.isRequired,
  formData: PropTypes.shape({
    modifierName: PropTypes.string,
    rulesCriteria: PropTypes.string,
    rulesPriority: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    multiplierValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    activeStartDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date)
    ]),
    activeEndDate: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date)
    ]),
    hasEndDate: PropTypes.bool,
    segment: PropTypes.string,
    channel: PropTypes.string,
    category: PropTypes.string,
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  channelJsonSchema: PropTypes.shape({
    properties: PropTypes.shape({
      channel: PropTypes.shape({
        options: PropTypes.array
      })
    })
  }).isRequired,
  categoryJsonSchema: PropTypes.shape({
    properties: PropTypes.shape({
      category: PropTypes.shape({
        options: PropTypes.array
      })
    })
  }).isRequired,
  rulesCriteriaJsonSchema: PropTypes.shape({
    properties: PropTypes.shape({
      rulesCriteria: PropTypes.shape({
        options: PropTypes.array
      })
    })
  }).isRequired,
  segmentJsonSchema: PropTypes.shape({
    properties: PropTypes.shape({
      segment: PropTypes.shape({
        options: PropTypes.array
      })
    })
  }).isRequired,
  formError: PropTypes.shape({
    modifierName: PropTypes.string,
    rulesCriteria: PropTypes.string,
    rulesPriority: PropTypes.string,
    multiplierValue: PropTypes.string,
    activeStartDate: PropTypes.string,
    activeEndDate: PropTypes.string,
    segment: PropTypes.string,
    category: PropTypes.string,
    channel: PropTypes.string
  }).isRequired,
  setDisableNext: PropTypes.func.isRequired,
  setFormData: PropTypes.func.isRequired
};
